import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

export const dict = {
  ro: {
    nav: { story: "Poveste", founder: "Fondatoarea", lookbook: "Colecție", custom: "La comandă", contact: "Contact" },
    hero: {
      eyebrow: "Atelier handmade, Timișoara, România",
      line1: "Croșetat",
      line2: "cu suflet,",
      line3: "la comandă.",
      sub: "De peste 30 de ani, fiecare piesă Nodino este lucrată manual: un fir, o croșetă și o idee nouă în fiecare dimineață.",
      cta: "Descoperă colecția",
      scroll: "Derulează",
    },
    manifesto: {
      eyebrow: "Povestea Nodino",
      title: "Înainte să existe un nume,\nexista o pasiune.",
      chapters: [
        "Înainte să existe Nodino, exista o femeie care nu putea sta o zi fără să creeze ceva.",
        "De peste 30 de ani, fiecare dimineață începe la fel: un fir, o croșetă și o idee nouă.",
        "Nu a ales niciodată calea ușoară. A ales să creeze cu mâinile ei. Genți. Cardigane. Decorațiuni. Jucării. Cadouri.",
        "Și sute de comenzi unice, făcute pentru oameni care au vrut ceva ce nu se găsește pe raft.",
        "Astăzi, aceeași pasiune poartă un nume. Nodino.",
      ],
    },
    founder: {
      eyebrow: "Fondatoarea",
      name: "Simona",
      title: "Mâinile din spatele fiecărei piese.",
      p1: "Simona croșetează de peste trei decenii. Ceea ce a început ca o pasiune a devenit un limbaj al răbdării, al detaliului și al dragostei pusă în fiecare nod.",
      p2: "Din atelierul ei personal din Timișoara, dă viață genților, cardiganelor, decorațiunilor și jucăriilor, fiecare gândită pentru o singură persoană.",
      stats: [
        { k: "30+", v: "ani de măiestrie" },
        { k: "100%", v: "lucrat manual" },
        { k: "∞", v: "piese unice" },
      ],
    },
    lookbook: {
      eyebrow: "Colecția",
      title: "Piese lucrate manual",
      sub: "Fiecare model poate fi personalizat: culoare, mărime, detalii. Fără două piese identice.",
      filters: { all: "Toate", garments: "Cardigane & Haine", bags: "Genți", toys: "Jucării" },
    },
    custom: {
      eyebrow: "La comandă",
      title: "Fiecare produs se face\ncum dorești tu.",
      p: "Nu vindem de pe raft. Fiecare piesă Nodino pornește de la o conversație: alegi modelul, culoarea firului, mărimea și detaliile. Prețul depinde de ceea ce îți dorești. Spune-ne ideea ta.",
      steps: [
        { t: "Spune-ne ideea", d: "Trimite-ne inspirația, culorile și modelul dorit." },
        { t: "Alegem împreună", d: "Firul, textura și detaliile care ți se potrivesc." },
        { t: "Lucrat manual", d: "Piesa ta unică prinde viață în atelier, nod cu nod." },
      ],
      cta: "Cere o comandă personalizată",
    },
    marquee: ["Handmade", "Croșetat", "La comandă", "Timișoara", "Măiestrie", "Eleganță"],
    contact: {
      eyebrow: "Contact",
      title: "Hai să creăm ceva\nnumai al tău.",
      sub: "Completează câmpurile de mai jos, iar aplicația ta de email se va deschide cu mesajul pregătit.",
      name: "Numele tău",
      email: "Emailul tău (opțional)",
      message: "Povestește-ne ce îți dorești",
      send: "Trimite mesajul",
      or: "sau scrie-ne direct",
      location: "Atelier personal, Timișoara, România",
      followUs: "Urmărește-ne",
      rights: "Toate drepturile rezervate.",
      madeWith: "Lucrat manual cu drag în Timișoara.",
    },
  },
  en: {
    nav: { story: "Story", founder: "Founder", lookbook: "Lookbook", custom: "Made to order", contact: "Contact" },
    hero: {
      eyebrow: "Handmade atelier, Timișoara, Romania",
      line1: "Crocheted",
      line2: "with soul,",
      line3: "made to order.",
      sub: "For over 30 years, every Nodino piece has been made by hand: a thread, a crochet hook and a new idea each morning.",
      cta: "Explore the collection",
      scroll: "Scroll",
    },
    manifesto: {
      eyebrow: "The Nodino story",
      title: "Before there was a name,\nthere was a passion.",
      chapters: [
        "Before Nodino existed, there was a woman who couldn't go a single day without creating something.",
        "For over 30 years, every morning begins the same way: a thread, a crochet hook and a new idea.",
        "She never chose the easy path. She chose to create with her own hands. Bags. Cardigans. Decorations. Toys. Gifts.",
        "And hundreds of unique orders, made for people who wanted something you can't find on a shelf.",
        "Today, that same passion carries a name. Nodino.",
      ],
    },
    founder: {
      eyebrow: "The Founder",
      name: "Simona",
      title: "The hands behind every piece.",
      p1: "Simona has been crocheting for over three decades. What began as a passion became a language of patience, of detail, of love woven into every knot.",
      p2: "From her personal atelier in Timișoara, she brings to life bags, cardigans, decorations and toys, each one made for a single person.",
      stats: [
        { k: "30+", v: "years of craft" },
        { k: "100%", v: "made by hand" },
        { k: "∞", v: "unique pieces" },
      ],
    },
    lookbook: {
      eyebrow: "The Collection",
      title: "Pieces made by hand",
      sub: "Every design can be personalized: colour, size, details. No two pieces alike.",
      filters: { all: "All", garments: "Cardigans & Wear", bags: "Bags", toys: "Toys" },
    },
    custom: {
      eyebrow: "Made to order",
      title: "Every piece is made\njust the way you want.",
      p: "We don't sell off the shelf. Every Nodino piece starts with a conversation: you choose the design, the yarn colour, the size and the details. The price depends on what you want. Tell us your idea.",
      steps: [
        { t: "Tell us your idea", d: "Share your inspiration, colours and the design you want." },
        { t: "We choose together", d: "The yarn, texture and details that suit you best." },
        { t: "Made by hand", d: "Your unique piece comes to life in the atelier, knot by knot." },
      ],
      cta: "Request a custom order",
    },
    marquee: ["Handmade", "Crochet", "Made to order", "Timișoara", "Craftsmanship", "Elegance"],
    contact: {
      eyebrow: "Contact",
      title: "Let's create something\nthat's only yours.",
      sub: "Fill in the fields below and your email app will open with the message ready to send.",
      name: "Your name",
      email: "Your email (optional)",
      message: "Tell us what you'd like",
      send: "Send message",
      or: "or write to us directly",
      location: "Personal atelier, Timișoara, Romania",
      followUs: "Follow us",
      rights: "All rights reserved.",
      madeWith: "Handmade with love in Timișoara.",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("ro");
  const toggle = useCallback(() => setLang((l) => (l === "ro" ? "en" : "ro")), []);
  const value = useMemo(() => ({ lang, setLang, toggle, t: dict[lang] }), [lang, toggle]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
